import moment from 'moment';

const _second = 1000;
const _minute = _second * 60;
const _hour = _minute * 60;
const _day = _hour * 24;

export async function countdownTimer(_endDate, setCountdownTime, currentTime = new Date()) {
    const interval = setInterval(() => {
        let timeNow = new moment.utc(currentTime.add(1, 'seconds'));
        var result = new Date(_endDate - timeNow);

        var d = Math.floor(result / _day);
        var h = Math.floor((result % _day) / _hour);
        var m = Math.floor((result % _hour) / _minute);
        var s = Math.floor((result % _minute) / _second);

        setCountdownTime({ days: d, hours: h, minutes: m, seconds: s });
    }, 1000);

    return () => clearInterval(interval);
};